import { useQuery } from '@tanstack/react-query';

import { getHttpStatus } from '../../../lib/apiError';
import type { ExtranetMeOutput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/users/me` — rôles fonctionnels et périmètre de l'appelant. C'est la
 * seule source du gating UI (le JWT ne porte pas les rôles `Extranet_*`).
 * On ne réessaie que les erreurs réseau : un 401/403 est définitif.
 */
export const useMeAccess = () =>
  useQuery({
    queryKey: extranetQueryKeys.account.me(),
    queryFn: () => getExtranetApi().get<Record<string, never>, ExtranetMeOutput>('/v1/users/me', {}),
    staleTime: 60 * 1000,
    retry: (failureCount, error) => getHttpStatus(error) === undefined && failureCount < 2,
  });
